import React, { useEffect, useState } from "react";
import "../../styles/admins/dashboard.css";
import {useNavigate} from 'react-router-dom';
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function AdminDashboard(props) {
  const [companies, setCompanies] = useState([]);
  const [modulo, setModulo] = useState(0);
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  // Fetch companies
  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/companies"
        );
        setCompanies(response.data);
        setModulo(response.data.length % 3);
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    const getTicketsData = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/tickets"
        );
        setTickets(response.data);
        localStorage.setItem("tickets", JSON.stringify(response.data));
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getCompanies();
    getTicketsData();
  }, [props]);

  function openTickets(id) {
    const filtr = tickets.filter(
      (elm) => elm.assign_comp === id && elm.status === "Open"
    );
    return filtr.length;
  }

  function closeTickets(id) {
    const filtr = tickets.filter(
      (elm) => elm.assign_comp === id && elm.status === "Closed"
    );
    return filtr.length;
  }

  const getPieData = (companyId) => {
  const open = openTickets(companyId);
  const close = closeTickets(companyId);

  return {
    labels: ["Open", "Close"],
    datasets: [
      {
        data: [open, close],
        backgroundColor: ["#ff6384", "#36a2eb"],
        borderWidth: 1,
      },
    ],
  };
};


  return (
   <section className="px-4">
   
      {/* <br /> */}
      <div
       className="row px-2"
      >
        {companies.map((comp, index) => (
       <div className="col-lg-4 col-md-6 my-1">
        <div
  key={index}
  className="dash-container"
  // style={{
  //   height: "14em",
  // }}
onClick={() => navigate('/admin/tickets', { state: { companyId: comp.id } })}
>
    <p className="comp-name">{comp.company_name}</p>

  <div   
  // style={{
  //   display: "flex",
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  //   alignItems: "center",

  // }}

    style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "10px",
    flex: 1,
  }}
>
  {/* Left side: Ticket Info */}
  <div style={{ flex: 2 }}>
    <p className="total-tickets">
      Total Tickets: {openTickets(comp.id) + closeTickets(comp.id)}
    </p>
    <p className="open-tickets">Open Tickets: {openTickets(comp.id)}</p>
    <p className="close-tickets">Close Tickets: {closeTickets(comp.id)}</p>
  </div>

  {/* Right side: Pie Chart */}
  <div
  //  style={{ flex: 1 }}
    style={{
    width: "150px",
    height: "150px",
    position: "relative",
  }}

  >
    <Pie
      data={getPieData(comp.id)} 
      options={{
          responsive: true,
      maintainAspectRatio: false,
        plugins: { legend: { display: true, position: "bottom" } },
        maintainAspectRatio: false,
      }}
    />
  </div>
  </div>
</div>
</div>
        ))}
        {Array.from({ length: 3 - modulo }).map((_, index) => (
          <div key={index} className="dash-container dummy-container mb-2"></div>
        ))}
      </div>
    </section>
  );
}

export default AdminDashboard;
